/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { NodePaging } from '../model/nodePaging';
import { PersonPaging } from '../model/personPaging';
import { SitePaging } from '../model/sitePaging';
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
import { buildCollectionParam } from '../../../alfrescoApiClient';
export class QueriesApi extends BaseApi {
    findNodes(term, opts) {
        throwIfNotDefined(term, 'term');
        const queryParams = {
            term,
            rootNodeId: opts === null || opts === void 0 ? void 0 : opts.rootNodeId,
            skipCount: opts === null || opts === void 0 ? void 0 : opts.skipCount,
            maxItems: opts === null || opts === void 0 ? void 0 : opts.maxItems,
            nodeType: opts === null || opts === void 0 ? void 0 : opts.nodeType,
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            orderBy: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.orderBy, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/queries/nodes',
            queryParams,
            returnType: NodePaging
        });
    }
    findPeople(term, opts) {
        throwIfNotDefined(term, 'term');
        opts = opts || {};
        const queryParams = {
            term,
            skipCount: opts === null || opts === void 0 ? void 0 : opts.skipCount,
            maxItems: opts === null || opts === void 0 ? void 0 : opts.maxItems,
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv'),
            orderBy: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.orderBy, 'csv')
        };
        return this.get({
            path: '/queries/people',
            queryParams,
            returnType: PersonPaging
        });
    }
    findSites(term, opts) {
        throwIfNotDefined(term, 'term');
        const queryParams = {
            term,
            skipCount: opts === null || opts === void 0 ? void 0 : opts.skipCount,
            maxItems: opts === null || opts === void 0 ? void 0 : opts.maxItems,
            orderBy: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.orderBy, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/queries/sites',
            queryParams,
            returnType: SitePaging
        });
    }
}
